import { createAction, props } from '@ngrx/store';
import { ParameterData } from 'src/app/pages/admin-manager/parameters/models/parameters.model';

export const loadParametersData = createAction('[Parameters Data] Load', props<{ payload: any }>());

export const requestParametersDataByKeys = createAction(
  '[Parameters Data] Request By Keys',
  props<{ keys: string[] }>(),
);

export const loadParametersDataSuccess = createAction('[Parameters Data] Load Success', props<{ response: string }>());

export const loadParametersDataSuccessByKey = createAction(
  '[Parameters Data] Load Success By Key',
  props<{ key: string; response: ParameterData }>(),
);

export const loadParametersDataSuccessMany = createAction(
  '[Parameters Data] Load Success Many',
  props<{ entries: Array<{ key: string; response: ParameterData }> }>(),
);

export const loadParametersDataFailureByKeys = createAction(
  '[Parameters Data] Load Failure By Keys',
  props<{ keys: string[]; error: any }>(),
);

export const loadParametersDataFailure = createAction('[Parameters Data] Load Failure', props<{ error: any }>());
